import { searchSlice } from '../reducers/search.reducers'

export const {
  updateSearchInputAction,
  updateSearchQueryAction,
} = searchSlice.actions
